export class PopoverSubtitleStyle {
  size = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  color = '';
  alignment = '';
  marginTop = 'uk-margin-top';

  static normalize(styles: Partial<PopoverSubtitleStyle>): PopoverSubtitleStyle {
    const pureStyles = new PopoverSubtitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
